import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { StaticbarService, ObservableService, ObservableInfo, UserService } from '../../services';
import { SidebarWsBookmarked, UserInfo } from '../../models';
import { ToastService } from 'src/app/services';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {

  bookmarked: SidebarWsBookmarked[];
  actualRoute: string;
  user: UserInfo;
  sidebarElementList = [
    {
      route: '',
      title: 'Home',
      icon: 'home_',
      children: false,
      exact: true,
    },
    {
      route: '/workspaces',
      title: 'Workspaces',
      icon: 'workspace_',
      children: true,
      exact: false,
    },
    {
      route: '/collaborators',
      title: 'Collaborators',
      icon: 'collaborators_',
      children: false,
      exact: false,
    },
    {
      route: '/inbox',
      title: 'Inbox',
      icon: 'inbox_',
      children: false,
      exact: false,
    },
    {
      route: '/trash',
      title: 'Trash',
      icon: 'trash_',
      children: false,
      exact: false,
    }
  ];

  constructor(
    private route: Router,
    private observableService: ObservableService,
    private staticbarService: StaticbarService,
    private userService: UserService,
    private toastService: ToastService) {

    route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.actualRoute = event.url;
      }
    });
  }

  async ngOnInit() {
    try {
      this.user = await this.userService.getUserInfo();
      // TODO Vedere come ottimizzare
      // if (this.user?.role === 'Admin' ) {
      //   this.sidebarElementList.splice(2, 0, {
      //     route: '/collaborators',
      //     title: 'Collaborators',
      //     icon: 'collaborators_',
      //     children: false,
      //     exact: false,
      //   });
      // }
      this.getFavouriteWorkspace();
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }

    /**
     * The observable is subscribed when a favorite workspaces
     * present in the sidebar is renamed or deleted
     * and trigger the action
     */

    this.observableService.update.subscribe((data: ObservableInfo) => {
      if (!data) { return; }
      switch (data.name) {
        case 'favourite':
          this.updateFavourite(data);
          break;
        case 'rename':
          this.getFavouriteWorkspace();
          break;

        default:
          break;
      }
    });
  }

  /**
   * Returns the list of favorite workspaces
   */

  async getFavouriteWorkspace() {
    try {
      this.bookmarked = (await this.staticbarService.getFavouriteWorkspaces()).bookmarked;
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Manages adding or removing a workspace from favorites
   * @param data Observable that contains the workspace
   */

  updateFavourite(data: ObservableInfo) {
    if (data.state) {
      this.bookmarked.push({
        id: data.update.id,
        name: data.update.name,
        type: data.update.type
      });
    } else {
      this.bookmarked = this.bookmarked.filter(item => item.id !== data.update.id);
    }
  }
}
